var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.benefitsBlockFormatter = {
    attach: function (context) {
      var $template = $('.js-editorial-product-partial-v1', context);
      var $addToBag = $('.js-btn-add-to-bag', $template);
      var $close = $('.js-slide-content-panel-close', context);

      $addToBag.once().on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this);
        var skuIds = $this.data('skubaseid');
        var payload = {};

        payload.quantity = 1;
        payload.INCREMENT = 1;
        payload.replenishment = false;
        $(document).trigger('perlgem.cart.addItem', [skuIds, payload]);
        $close.trigger('click');
      });
    }
  };
})(jQuery);
